import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import LoadingSpinner from 'components/LoadingSpinner'
import { useCurrentPractice } from 'contexts/PracticeContext'
import { selectUser } from 'selectors/auth'
import { isRebateEnabled } from 'util/practice'

const RebatesGuard = ({ children }) => {
	const { currentPracticeObject } = useCurrentPractice()
	const user = useSelector(selectUser)
	const navigate = useNavigate()

	const isLoading = isEmpty(currentPracticeObject) || isEmpty(user)

	useEffect(() => {
		if (isLoading) return

		if (!isRebateEnabled(currentPracticeObject)) {
			navigate('/')
		}
	}, [isLoading, currentPracticeObject, navigate])

	if (isLoading) {
		return <LoadingSpinner />
	}

	return <>{children}</>
}

export default RebatesGuard
